<script>
import { mapGetters } from 'vuex'
import TitleCountSpentProducts from './titleCountSpentProducts'
import QrCounterSpentProducts from './qrCounterSpentProducts'
import SpentProducts from './spentProducts'
import PendingProducts from './pendingProducts'

export default {
  name: 'CountSpentProducts',
  components: {
    TitleCountSpentProducts,
    QrCounterSpentProducts,
    SpentProducts,
    PendingProducts,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      inventory_count_spent_products:
        'retina/inventory/inventory_count_spent_products',
      spent: 'retina/inventory/spent',
      pending: 'retina/inventory/pending',
      total_spent: 'retina/inventory/total_spent',
      total_spent_quantity: 'retina/inventory/total_spent_quantity',
      total_pending: 'retina/inventory/total_pending',
      total_pending_quantity: 'retina/inventory/total_pending_quantity',
    }),
  },
  methods: {
  },
  mounted() {
  }
}
</script>
<template>
  <div v-if="inventory_count_spent_products">
    <div class="row mb-2">
      <div class="col-md-12 col-xl-5">
        <TitleCountSpentProducts />
      </div>
      <div class="col-md-12 col-xl-5">
        <QrCounterSpentProducts />
      </div>
    </div>

    <div>
      <b-tabs id="menu-tabs"  active-nav-item-class="font-weight-bold text-blue" 
        nav-class="text-center" content-class="bg-white">
        <b-tab active title-link-class="m-0 px-1 py-2 pl-2 font-weight-light">
          <template #title>
            <i class="fas fa-box-open mr-1 fa-lg"></i>
              <br>
            <strong>Consumidos </strong>
            <b-badge :variant="total_spent_quantity > 0 ? 'blue' : 'light'">{{ total_spent_quantity }}</b-badge>
          </template>
          <SpentProducts />
        </b-tab>
        <b-tab title-link-class="m-0 px-1 py-2 pl-2 font-weight-light">
          <template #title>
          <i class="fas fa-bell mr-1 fa-lg"></i>
            <br>
            <strong>Pendientes </strong>
            <b-badge :variant="total_pending_quantity > 0 ? 'blue' : 'light'">{{ total_pending_quantity }}</b-badge>
          </template>
          <PendingProducts />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<style lang="scss">
@media screen and (max-width: 765px) {
  #menu-tabs .nav-item {
    width: 33.3333%;
  }
}
@media screen and (min-width: 766px) {
  #menu-tabs .nav-item {
    min-width: 110px;
  }
}
</style>